import { REQUIRED_ROLES } from "./rquired-roles";

export const detailedInspectionRequestsRoutes =   {
    path: '/detailed-inspection-requests',
    name: 'DetailedInspectionRequests',
    meta: {
        authorized: true,
        roles: REQUIRED_ROLES['detailed-inspection-requests']
      },
      component: () => import("@/views/detailed-inspection-requests/index.vue"),
      children: [
        {
          path: '',
          name: 'DetailedInspectionRequestsList',
          meta: {
            authorized: true,
            roles: REQUIRED_ROLES['detailed-inspection-requests']
          },
          component: () => import('@/views/detailed-inspection-requests/list/index.vue'),
        },
        {
          path: ':id/edit',
          name: 'DetailedInspectionRequestsEdit',
          meta: {
            authorized: true,
            roles: REQUIRED_ROLES['detailed-inspection-requests']
          },
          component: () => import('@/views/detailed-inspection-requests/edit/index.vue'),
        },
        {
          path: ':id/results',
          name: 'DetailedInspectionRequestsResults',
          meta: {
            authorized: true,
            roles: REQUIRED_ROLES['detailed-inspection-requests']
          },
          component: () => import('@/views/detailed-inspection-requests/results/index.vue'),
        },
      ],
    }